document.addEventListener('DOMContentLoaded', function() {

  var mainImg = document.querySelector('.product-main-img img');
  var thumbs = document.querySelectorAll('.product-thumb img');
  var optionBtns = document.querySelectorAll('.product-option-btn');
  var select = document.querySelector('select[name="id"]');
  var priceContainer = document.querySelector('.product-price');
  var addBtn = document.querySelector('.product-add-btn');
  var variantDataEl = document.querySelector('[data-product-variants]');
  var variantData = [];
  if (variantDataEl) {
    try { variantData = JSON.parse(variantDataEl.textContent); } catch (e) { variantData = []; }
  }

  function findVariant(id) {
    for (var i = 0; i < variantData.length; i++) {
      if (String(variantData[i].id) === String(id)) return variantData[i];
    }
    return null;
  }

  function renderPrice(variant) {
    if (!priceContainer || !variant) return;
    var html = '<span class="product-price-amount">' + variant.price_html + '</span>';
    if (variant.compare_at_html) {
      html += '<span class="product-compare">' + variant.compare_at_html + '</span>';
      html += '<span class="product-sale-badge">SALE</span>';
    }
    priceContainer.innerHTML = html;
  }

  function renderAvailability(variant) {
    if (!addBtn || !variant) return;
    if (variant.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
    }
  }

  // OPTION BUTTONS
  optionBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Update active state
      var group = btn.closest('.product-options');
      if (group) {
        group.querySelectorAll('.product-option-btn').forEach(function(b) {
          b.classList.remove('active');
        });
      }
      btn.classList.add('active');

      // Update hidden select for cart
      var value = btn.textContent.trim();
      if (select) {
        Array.from(select.options).forEach(function(option) {
          if (option.text.toLowerCase().includes(value.toLowerCase())) {
            select.value = option.value;
          }
        });
      }

      // Update price + availability to match the now-selected variant
      var variant = findVariant(select ? select.value : null);
      renderPrice(variant);
      renderAvailability(variant);

      // Swap image
      var colorMap = { 'pink': 0, 'blue': 1, 'white': 2, 'natural': 0, 'dark': 1, 'chrome': 0, 'matte black': 1, 'black': 1 };
      var index = colorMap[value.toLowerCase()];
      if (index !== undefined && thumbs[index] && mainImg) {
        mainImg.src = thumbs[index].src.replace('200x200', '600x600').replace('_200x', '_600x');
        mainImg.alt = thumbs[index].alt;
      }
    });
  });

  // THUMBNAIL CLICK
  thumbs.forEach(function(thumb) {
    thumb.parentElement.addEventListener('click', function() {
      if (mainImg) {
        mainImg.src = thumb.src.replace('200x200', '600x600').replace('_200x', '_600x');
        mainImg.alt = thumb.alt;
      }
    });
  });

  // QTY BUTTONS
  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = btn.closest('.qty-input');
      var num = wrap.querySelector('.qty-num');
      var input = wrap.querySelector('input[name="quantity"]');
      var val = parseInt(num.textContent) || 1;
      if (btn.dataset.action === 'minus' && val > 1) val--;
      if (btn.dataset.action === 'plus') val++;
      num.textContent = val;
      if (input) input.value = val;
    });
  });

});
